import {
  OnlineBookingAction,
  PatientAction,
} from './patient/patient-portal/patient-portal';

export type RecaptchaAction = OnlineBookingAction | PatientAction;

export interface IRecaptchaActionConfig {
  minimumScore: number;
}

export interface IRecaptchaConfig {
  ipBlacklist: string[];
  minimumScore: number;
  actionConfigs: Partial<Record<RecaptchaAction, IRecaptchaActionConfig>>;
}
